import * as React from "react";
import { Form, Input, Button, Row } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

const LoginForm = ({
  translate,
  username,
  password,
  onChangeUsername,
  onChangePassword,
  login,
  loginButtonDisabled,
  loading
}: {
  translate: any;
  username: string;
  password: string;
  onChangeUsername: any;
  onChangePassword: any;
  login: any;
  loginButtonDisabled: boolean;
  loading: boolean;
}) => {
  return (
    <React.Fragment>
      <Form className="login-form-container">
        <Input
          prefix={<UserOutlined />}
          placeholder={translate("device_management_page.modal_username")}
          allowClear={true}
          value={username}
          onChange={(e) => onChangeUsername(e.target.value)}
          style={{ marginTop: 10, marginBottom: 10 }}
          autoFocus={true}
        />

        <Input.Password
          prefix={<LockOutlined />}
          placeholder={translate("device_management_page.modal_password")}
          allowClear={true}
          value={password}
          onChange={(e) => onChangePassword(e.target.value)}
          onPressEnter={login}
          style={{ marginTop: 10, marginBottom: 10 }}
        />
        <Row
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
          <Button
            className="button-primary"
            key="submit"
            onClick={login}
            disabled={loginButtonDisabled}
            loading={loading}>
            {translate("login.submit_button")}
          </Button>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default LoginForm;
